export const fmtKg = (n) => {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-ZA", { maximumFractionDigits: 1 }).format(n);
};

export const fmtTonnes = (n) => {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-ZA", { maximumFractionDigits: 2 }).format(n / 1000);
};

export const fmtInt = (n) => (n == null ? "—" : new Intl.NumberFormat("en-ZA").format(n));

export const fmtPct = (n) => (n == null ? "—" : `${Number(n).toFixed(1)}%`);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-ZA", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-ZA", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
      timeZone: "Africa/Johannesburg",
    });
  } catch {
    return iso;
  }
};

export const monthLabel = (ym) => {
  if (!ym) return ym;
  const [y, m] = ym.split("-");
  const d = new Date(Number(y), Number(m) - 1, 1);
  return d.toLocaleDateString("en-ZA", { month: "short", year: "2-digit" });
};

export const CHART_COLORS = ["#7C3AED", "#0D9488", "#D97706", "#2563EB", "#DB2777", "#059669", "#9333EA", "#CA8A04"];
